<template>
	<form class="receipts-filter-form" @submit.prevent>
		<div class="filter-fields">
			<default-field-box
				type="text"
				name="search"
				:placeholder="$t('receipts.search_placeholder')"
				event="field-changed"
			/>
			<default-field-box
				type="date"
				name="date_from"
				:placeholder="$t('receipts.filter_from')"
				event="field-changed"
			/>
			<default-field-box
				type="date"
				name="date_to"
				:placeholder="$t('receipts.filter_to')"
				event="field-changed"
			/>
		</div>
		<button class="button style-1" type="button" :class="loading ? 'loading' : ''" :disabled="loading" @click.prevent="onExport">
			<span class="inner"><i class="fa-thin fa-file-export"></i> {{ $t('receipts.export') }}</span>
		</button>
	</form>
</template>

<script>
	import DefaultFieldBox from "../form-fields/DefaultFieldBox";
	import { trackEvent } from '@/analytics';

	export default {
		name: "ReceiptsFilterForm",
		components: {
			DefaultFieldBox
		},
		props: {
			filteredIds: {
				type: Array,
				default: null,
			},
		},
		data() {
			return {
				loading: false,
			};
		},
		methods: {
			async onExport() {
				if (this.loading) return;
				this.loading = true;
				trackEvent('receipt_export_start', { module: 'receipts' });
				try {
					const payload = this.filteredIds ? { ids: this.filteredIds } : {};
					await this.axios.post('/api/receipts/export', payload);
					trackEvent('receipt_export_success', { module: 'receipts' });
					await this.$swal.fire({
						icon: 'success',
						title: this.$t('receipts.export_success_title'),
						text: this.$t('receipts.export_success_text'),
					});
				} catch (error) {
					trackEvent('receipt_export_error', {
						module: 'receipts',
						error_message: error.response?.data?.message || error.message,
						error_status: error.response ? String(error.response.status) : null,
					});
					this.$swal.fire({
						icon: 'error',
						title: 'Oops',
						text: error.response?.data?.message || this.$t('general.default_error'),
					});
				} finally {
					this.loading = false;
				}
			},
		},
	}
</script>

<style lang="scss">
	.receipts-filter-form {
		display: flex;
		align-items: center;
		margin-bottom: 20px;

		&:last-child {
			margin-bottom: 0;
		}

		@media($tabletL){
			flex-direction: column;
			align-items: flex-start;
			gap: 20px;
			.button {
				width: 100%;
			}
		}
	}

	.filter-fields {
		display: flex;
		flex-grow: 1;
		align-items: flex-end;
		gap: 10px;

		.form-group {
			margin-bottom: 0;

			&:first-child {
				min-width: 230px;
			}

			&:not(:first-child) {
				width: 125px;
				flex-shrink: 0;
			}
		}

		@media($tabletL){
			width: 100%;
			.form-group {
				&:first-child {
					flex-grow: 1;
				}
			}
		}

		@media ($tabletS) {
			flex-wrap: wrap;

			.form-group {
				&:first-child {
					width: 100%;
					flex-grow: 1;
					flex-basis: 100%;
				}

				&:not(:first-child) {
					width: calc(50% - 5px);
					flex-shrink: 1;
				}
			}
		}

		@media ($mobileM) {
			width: 100%;

			.form-group {
				width: 100%;
			}
		}
	}
</style>
